<template>
  <div class="feedback-info-page">
    <el-card class="app-table-container" :body-style="{ padding: '0' }">
      <div class="feedback-main">
        <div class="feedback-main-left">
          <div class="feedback-main-left-btn">
            <button
              class="global-button-style"
              @click="dialogSearchVisible = !dialogSearchVisible"
            >
              搜索
            </button>
            <div class="feedback-main-left-select">
              <el-select v-model="sortType" @change="sortSessionList">
                <el-option
                  v-for="item in sortOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="feedback-main-left-sortBy" @click="sortByTime">
                <i
                  class="el-icon-caret-top feedback-main-left-icon"
                  :class="{ activeSortIcon: sortIcon === 'up' }"
                ></i>
                <i
                  class="el-icon-caret-bottom feedback-main-left-icon"
                  :class="{ activeSortIcon: sortIcon === 'down' }"
                ></i>
              </div>
            </div>
          </div>
          <div v-bar>
            <div class="feedback-main-list">
              <div
                class="feedback-main-item"
                :class="{
                  activeUserItem: sessionDbID === item.dbId,
                }"
                v-for="(item, idx) in sessionList"
                :key="idx"
                @click="handleUserItem(item)"
              >
                <span
                  @click.stop="delConversation(item)"
                  class="feedback-del-btn el-icon-close"
                ></span>
                <img
                  class="feedback-main-item-pic"
                  src="@/assets/img/cmb_temp_potrait.png"
                  alt="potrait"
                />
                <div class="feedback-main-item-info">
                  <div class="feedback-main-item-Top">
                    <p class="feedback-main-item-account" v-if="item">
                      {{ item.name || item.user }}
                    </p>
                    <p
                      v-if="item.unReadCount"
                      class="feedback-main-item-unReadCount"
                    >
                      {{ item.unReadCount }}
                    </p>
                  </div>
                  <div class="feedback-main-item-Bottom">
                    <p class="feedback-main-item-msg">
                      {{ item.lastMessage ? item.lastMessage : "" }}
                    </p>
                    <p class="feedback-main-item-text">
                      {{ item.createdAt | filterTime }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="feedback-main-right" v-if="sessionItem">
          <div class="feedback-userName">
            <template>
              <h2 v-if="currentRemark">
                {{ currentRemark.remark }} （
                {{ sessionItem.name ? sessionItem.name : sessionDbID }}
                ）
              </h2>
              <h2 v-else>
                {{ sessionItem.name ? sessionItem.name : sessionDbID }}
              </h2>
            </template>
            <div class="blackListBtn">
              <button class="global-button-style" @click="showRemarkInput">
                备注
              </button>
            </div>
            <div class="blackListBtn">
              <button class="global-button-style" @click="addBlackList">
                黑名单
              </button>
            </div>
          </div>
          <div class="feedback-content" v-bar>
            <div
              v-if="isShowScrollButtomTips"
              class="scrollButtomTips"
              @click="scrollToBottom"
            >
              回到最新
            </div>
            <div style="flex: 1" ref="feedbackContent" @scroll="onScroll">
              <!-- <p v-if="!isCompleted" class="checkMore-btn" @click="checkMore">
                查看更多
              </p>
              <p class="feedbackContent-noMore" v-else>没有更多了...</p> -->
              <div
                class="feedbacl-content-item"
                v-for="(item, index) in msgList"
                :key="item.uniqueId"
                :id="item.msgKey ? item.msgKey : item.uniqueId"
                ref="contentItem"
              >
                <div class="feedbacl-content-info" v-if="item.msgType === 0">
                  <img
                    class="feedback-content-item-pic"
                    src="@/assets/img/cmb_temp_potrait.png"
                    alt="potrait"
                  />

                  <div class="feedback-content-item-info">
                    <div class="feedback-content-item-text-warp">
                      <p
                        class="feedback-content-item-text"
                        v-html="filterDesc(item.desc)"
                      ></p>
                      <template v-if="item.uniqueId">
                        <img
                          v-if="!item.tags || !item.tags.length"
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_noTag.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                        <img
                          v-else-if="item.tags.length === 1"
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_tag.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                        <img
                          v-else
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_tags.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                      </template>
                    </div>
                    <div
                      v-if="item.tags && item.tags.length"
                      class="feedback-content-item-firmware"
                    >
                      标签：
                      <span
                        class="feedback-tag-value"
                        v-for="(tag, i) in item.tags"
                        :key="tag.key"
                      >
                        {{ tag.value }}
                        <i v-if="i !== item.tags.length - 1">、</i>
                      </span>
                    </div>

                    <div
                      class="feedback-content-item-firmware"
                      v-if="item.firmware"
                    >
                      <p v-if="item.firmware.model">
                        型号：{{ item.firmware.model }}
                      </p>
                      <p v-if="item.firmware.fingerprint">
                        版本：{{
                          item.firmware.fingerprint.split("/")[2].split(":")[1]
                        }}
                      </p>
                      <p v-if="item.firmware.deviceMAC">
                        MAC：{{ item.firmware.deviceMAC }}
                      </p>
                      <p v-if="item.firmware.version">
                        版本：{{ item.firmware.version }}
                      </p>
                      <p v-if="item.firmware.lang">
                        语言：{{ item.firmware.lang }}
                      </p>
                      <p v-if="item.firmware.server">
                        服务器：{{ item.firmware.server }}
                      </p>
                      <p v-if="item.serverInfo">
                        服务器：{{ item.serverInfo.onyxSend2BooxHostBaseUrl }}
                      </p>
                      <p v-if="item.firmware.buildDisplayId">
                        buildDisplayId：{{ item.firmware.buildDisplayId }}
                      </p>
                      <p v-if="item.firmware.buildType">
                        buildType：{{ item.firmware.buildType }}
                      </p>
                    </div>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.serialNumber"
                    >
                      SN码：{{ item.serialNumber }}
                    </p>
                    <p class="feedback-content-item-file" v-if="item.phone">
                      手机：{{ item.phone }}
                    </p>
                    <p class="feedback-content-item-file" v-if="item.email">
                      邮箱：{{ item.email }}
                    </p>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.uploadFileUrl"
                    >
                      附件：
                      <a
                        v-if="
                          item.uploadFileUrl.indexOf('onyx-log-collection') !==
                            -1 ||
                          item.uploadFileUrl.indexOf(
                            'onyx-log-collection-us'
                          ) !== -1
                        "
                        target="_blank"
                        class="feedback-content-item-fileUrl"
                        :href="item.uploadFileUrl"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <a
                        v-else-if="
                          item.uploadFileUrl.indexOf('oss-us-west-1') !== -1 &&
                          item.uploadFileUrl.indexOf(
                            'onyx-log-collection-us'
                          ) === -1
                        "
                        class="feedback-content-item-fileUrl"
                        target="_blank"
                        :href="`https://onyx-log-collection-us.${item.uploadFileUrl}`"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <a
                        v-else
                        class="feedback-content-item-fileUrl"
                        :href="item.uploadFileUrl"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <el-button
                        v-if="item.key"
                        type="primary"
                        size="mini"
                        @click="checkPsw(item)"
                        >密码查询</el-button
                      >
                    </p>
                    <p class="feedback-content-item-time">
                      {{ item.createdAt | filterTime }}
                    </p>
                  </div>
                </div>
                <div class="feedbacl-content-info feedbacl-content-out" v-else>
                  <div
                    v-if="item.isRevoke"
                    class="feedback-content-item-info feedbacl-content-out-text"
                  >
                    <div style="display: flex; align-items: center">
                      <p
                        class="feedback-content-item-text feedbacl-out-content-text"
                      >
                        消息已撤回
                      </p>
                    </div>

                    <p class="feedback-content-item-time">
                      {{ item.createdAt | filterTime }}
                    </p>
                  </div>
                  <div
                    v-else
                    class="feedback-content-item-info feedbacl-content-out-text"
                  >
                    <div style="display: flex; align-items: center">
                      <!-- 发送中：转圈 -->
                      <span
                        v-if="cbOutbox[item.uniqueId] === 'sending'"
                        class="feedback-sending-btn el-icon-loading"
                      ></span>
                      <!-- 发送失败：红叹号，可点重发 -->
                      <span
                        v-else-if="cbOutbox[item.uniqueId] === 'fail'"
                        @click.stop="resendMsg(item, index)"
                        class="feedback-sendFail-btn el-icon-warning"
                      ></span>
                      <p
                        class="feedback-content-item-text feedbacl-out-content-text"
                        v-html="filterDesc(item.desc)"
                      ></p>
                    </div>

                    <p
                      class="feedback-content-item-file"
                      v-if="item.uploadFileUrl"
                    >
                      附件：
                      <a
                        v-if="
                          item.uploadFileUrl.indexOf('onyx-log-collection') !==
                            -1 ||
                          item.uploadFileUrl.indexOf(
                            'onyx-log-collection-us'
                          ) !== -1
                        "
                        target="_blank"
                        class="feedback-content-item-fileUrl"
                        :href="item.uploadFileUrl"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <a
                        v-else-if="
                          item.uploadFileUrl.indexOf('oss-us-west-1') !== -1 &&
                          item.uploadFileUrl.indexOf(
                            'onyx-log-collection-us'
                          ) === -1
                        "
                        class="feedback-content-item-fileUrl"
                        target="_blank"
                        :href="`https://onyx-log-collection-us.${item.uploadFileUrl}`"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <a
                        v-else
                        class="feedback-content-item-fileUrl"
                        :href="item.uploadFileUrl"
                        download=""
                        >{{ item.uploadFileUrl.split("/").pop() }}</a
                      >
                      <el-button
                        v-if="item.key"
                        type="primary"
                        size="mini"
                        @click="checkPsw(item)"
                        >密码查询</el-button
                      >
                    </p>

                    <p class="feedback-content-item-time">
                      {{ item.createdAt | filterTime }}
                    </p>
                    <span
                      v-if="filterRevokeTime(item)"
                      @click.stop="revokeMsg(item)"
                      class="feedback-revoke-btn el-icon-close"
                    ></span>
                  </div>
                  <div class="feedback-content-item-pic-wrap">
                    <img
                      class="feedback-content-item-pic"
                      src="@/assets/img/cmb_temp_potrait.png"
                      alt="potrait"
                    />
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 附件上传 -->
          <div class="feedback-file">
            <el-upload
              class="upload"
              action=""
              ref="uploader"
              :on-change="handleChange"
              :show-file-list="false"
              :auto-upload="false"
            >
              <img
                slot="trigger"
                src="@/assets/img/icon_feedback_file.svg"
                alt=""
              />
            </el-upload>
            <!-- <div class="feedback-file-line"></div> -->
            <div class="feedback-upload-file" v-if="files.length">
              <el-tag
                v-for="file in files"
                :key="file.uid"
                closable
                @close="files = []"
                disable-transitions
              >
                {{ file.name }}
              </el-tag>
            </div>
          </div>
          <div class="feedback-input" v-loading="sending">
            <el-input
              v-model="content"
              placeholder="输入内容..."
              type="textarea"
              id="singleText"
              resize="none"
              @focus="focusInput"
              @keydown.enter.exact.prevent.native="sendMsg"
              @keyup.ctrl.enter.prevent.exact.native="handleLine"
            ></el-input>
            <div class="feedback-sendBtn">
              <Idioms @setIdioms="setIdioms" />
              <button @click="sendMsg" class="global-button-style">发送</button>
            </div>
          </div>
        </div>
        <div v-else class="feedback-main-right"></div>
      </div>
    </el-card>

    <el-dialog
      title="信息反馈搜索"
      class="feedback-dialog-main"
      :visible.sync="dialogSearchVisible"
    >
      <div class="feedback-dialogSearch-warp">
        <div class="feedback-dialogSearch-input">
          <el-select
            v-model="searchType"
            @change="changeSelectType"
            class="feedback-dialogSearch-select"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-input
            v-model="searchVal"
            placeholder="输入搜索内容"
            clearable
            @keydown.enter.native="feedbackSearch"
            ><i
              slot="suffix"
              class="el-input__icon el-icon-search feedback-dialogSearch-search-icon"
              @click.stop="feedbackSearch"
            ></i
          ></el-input>
        </div>
        <div class="feedback-searchList" v-bar>
          <div>
            <div
              v-for="item in limitSearchData"
              :key="item._id"
              class="feedback-searchItem"
              @click="searchToHandleUserItem(item)"
            >
              <img
                class="feedback-main-item-pic"
                src="@/assets/img/cmb_temp_potrait.png"
                alt="potrait"
              />
              <div class="feedback--searchItem-msgInfo">
                <h4>{{ item.name }}：</h4>
                <span v-html="searchKeyVal(item)"></span>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          layout="prev, pager, next"
          :pageSize="searchParams.limit"
          :total="searchCount"
          @pageNum="pageNum"
        />
      </div>
    </el-dialog>

    <el-dialog
      class="tagsTree-dialog"
      :visible.sync="showTagsTree"
      width="80%"
      title="标签"
      center
      @close="closeTagsPopver"
      @open="openTagsPopver"
    >
      <div class="feedback-tagsTree-header">
        <div class="feedback-tagsTree-selectTags">
          <span class="feedback-tag-value">已选：</span>
          <span
            class="feedback-tag-value"
            v-for="(tag, i) in currentMsgTags"
            :key="tag.key"
          >
            {{ tag.value }}
            <i v-if="i !== currentMsgTags.length - 1">、</i>
          </span>
        </div>
        <div class="feedback-tagsTree-btn">
          <Search
            class="feedback-tagsTree-search"
            @listSearchEvn="tagsTreeSearch"
          ></Search>
          <el-button @click="clearSelectTags">清空</el-button>
          <el-button type="primary" @click="tagsConfirm">确定</el-button>
        </div>
      </div>
      <div class="feedback-tagsTree" v-bar>
        <div>
          <div
            class="feedback-tagsFunct feedback-tags-item"
            v-for="(data, index) in tagsData"
            :key="data._id"
          >
            <div class="feedback-tags-item-left">
              <p class="feedback-tags-item-type">
                {{ index + 1 }}、{{ data.label }}
              </p>
              <div class="feedback-tags-funct-list" v-bar>
                <div>
                  <p
                    class="feedback-tags-funct-item"
                    :class="[
                      {
                        'active-functItem': item._id === data.selectItem._id,
                      },
                      { 'functItem-color': item.indeterminate },
                    ]"
                    v-for="item in data.list"
                    :key="item._id"
                    @click="setTagChildren(data, item)"
                  >
                    {{ item.value }}
                  </p>
                </div>
              </div>
            </div>
            <div class="feedback-tags-item-right" v-bar>
              <div>
                <div class="feedback-tags-list">
                  <div
                    class="feedback-tags-item-check"
                    v-for="item in data.selectItemChildren"
                    :key="item._id"
                  >
                    <el-checkbox
                      v-model="item.check"
                      @change="tagsSelectHandle(data, item)"
                    ></el-checkbox>
                    <p
                      class="omitText"
                      @click="
                        (item.check = !item.check), tagsSelectHandle(data, item)
                      "
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="备注"
      :visible.sync="showRemark"
      width="35%"
      center
      @close="clearRemark"
    >
      <div>
        <el-input
          v-model="remarkVal"
          @keyup.enter.native="setRemark"
          clearable
        ></el-input>
      </div>
      <span slot="footer">
        <el-button @click="clearRemark">取消</el-button>
        <el-button type="primary" @click="setRemark">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import OSS from "ali-oss";
import Pagination from "@/components/pagination";
import Search from "@/components/listSearch";
import Idioms from "../components/idioms";
export default {
  name: "sessionList",
  props: ["refresh"],
  components: {
    Pagination,
    Search,
    Idioms,
  },
  computed: {
    ...mapGetters([
      "cbMsgList",
      "cbUserList",
      "cbCurrentUser",
      "userInfo",
      "buckets",
      "cbOutbox",
    ]),
  },
  data() {
    return {
      sortOpts: [
        { label: "全部", value: "all" },
        { label: "已读", value: "read" },
        { label: "未读", value: "unread" },
      ],
      sortType: "all",
      sortIcon: "down",
      searchOptions: [
        { label: "内容", value: "desc" },
        { label: "用户名", value: "name" },
        { label: "备注", value: "remark" },
        { label: "MAC", value: "firmware.deviceMAC" },
        { label: "手机", value: "phone" },
        { label: "邮箱", value: "email" },
        { label: "型号", value: "firmware.model" },
        { label: "uniqueId", value: "uniqueId" },
      ],
      searchType: "desc",
      content: "",
      msgList: this.cbMsgList || [],
      sessionList: this.cbUserList || [],
      sessionItem: null,
      sessionDbID: "",
      currentUser: {
        payload: {
          text: {
            // name: "",
            // userID: ""
          },
        },
      },
      nextReqMessageID: "",
      isCompleted: false,
      imIsCompleted: false,
      firstItemID: "",
      isShowScrollButtomTips: false,
      dialogSearchVisible: false,
      popoverVisible: false,
      searchVal: "",
      searchCount: 0,
      searchList: [],
      limitSearchData: [],
      resendMessage: [],
      searchParams: {
        limit: 20,
        page: 1,
      },
      serverMsg: [],
      serverMsgCount: 0,
      serverMsgPage: 1,
      files: [],
      ossClient: null,
      uploadFileUrl: "",
      sending: false,
      currentMsgItem: null,
      currentMsgTagsKey: [],
      currentMsgTags: [],
      showTagsTree: false,
      defaultProps: {
        children: "children",
        label: "value",
      },
      tagLoading: false,
      defaultExpand: false,
      activeBtn: "active-tree-minus",
      tagsData: [],
      selectTags: [],
      tagsSearchValue: "",
      showRemark: false,
      remarkVal: "",
      remarkList: [],
      currentRemark: null,
    };
  },
  watch: {
    async cbMsgList() {
      this.msgList = this.cbMsgList;
      console.log("pzzz--watch--cbMsgList", this.cbMsgList);
    },
    async cbUserList() {
      this.getSessionList();
    },
    refresh() {
      this.getSessionList();
      this.checkMsgKey();
      this.scrollToBottom();
    },
  },
  methods: {
    async getRemark() {
      try {
        let res = await this.$http.getCbFeedbackRemark();
        this.remarkList = res.data;

        this.setCurrentRemark(this.sessionDbID);
      } catch (error) {
        console.log("error", error);
      }
    },
    setCurrentRemark(account) {
      if (!account) return;
      this.currentRemark = this.remarkList.find(
        (item) => item.account === account
      );
    },
    showRemarkInput() {
      this.showRemark = true;
    },

    clearRemark() {
      this.showRemark = false;
      this.remarkVal = "";
    },

    async setRemark() {
      await this.$http.addCbFeedbackRemark({
        account: this.sessionDbID,
        remark: this.remarkVal,
      });
      this.getRemark();
      this.clearRemark();
    },

    handleChange(file, files) {
      if (file.size > 20971520) {
        this.elMsg("文件大小超过20M限制", "error");
        return;
      }
      this.$nextTick(() => {
        this.files = [];
        this.files = [...this.files, file];
      });
    },

    uploadFileToOss() {
      return new Promise(async (resolve, reject) => {
        try {
          this.ossClient = await this.getOssClient();

          for (let item of this.files) {
            let file = item.raw;
            let format = file.name.split(".").pop();
            let randomName = `upload/${this.randomString(
              6
            )}-${new Date().getTime()}.${format}`;

            let ret = await this.ossClient.multipartUpload(randomName, file);
            this.uploadFileUrl = ret.res.requestUrls[0].split("?")[0];
            resolve("ok");
          }
          resolve("");
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.aliyunSts();
          let { region, bucket } = this.buckets["onyx-log"];
          let creds = res.data;
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket,
          });
          return resolve(client);
        } catch (error) {
          reject(error);
        }
      });
    },

    randomString(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    sortSessionList() {
      return new Promise((resolve, reject) => {
        let arr = Object.assign([], this.cbUserList);
        if (this.sortType === "all") {
          this.sessionList = arr;
        } else if (this.sortType === "read") {
          this.sessionList = arr.filter((item) => item.unReadCount === 0);
        } else if (this.sortType === "unread") {
          this.sessionList = arr.filter((item) => item.unReadCount >= 1);
        }
        if (this.sortIcon === "up") {
          this.sessionList.reverse();
        }
        resolve("ok");
      });
    },
    sortByTime() {
      this.sortIcon = this.sortIcon === "down" ? "up" : "down";
      this.sessionList.reverse();
    },
    filterLogUrl(url) {
      let arr = url.split("://");
      let path = `${arr[0]}://onyx-log-collection-us.${arr[1]}`;
      return path;
    },
    filterDesc(desc) {
      let val = desc ? desc.replace(/\n/g, "<br>") : "";
      return val;
    },
    changeSelectType() {
      this.searchVal = "";
      this.searchParams.page = 1;
      this.searchCount = 0;
      this.searchList = [];
      this.limitSearchData = [];
    },
    async feedbackSearch() {
      let params = {
        selector: {
          [this.searchType]: { $regex: RegExp(this.searchVal, "gi") },
          $or: [{ msgType: 0 }, { msgType: 1 }],
        },
      };
      let results = await this.$store.dispatch("getFeedbackMsgFromCb", params);
      if (!results.length) {
        this.elMsg("没有搜索到内容", "warning");
        return;
      }
      this.searchList = results.reverse();
      this.searchCount = results.length;
      this.cuttingData();
    },
    cuttingData() {
      this.limitSearchData = this.searchList.slice(
        (this.searchParams.page - 1) * this.searchParams.limit,
        this.searchParams.page * this.searchParams.limit
      );
    },
    pageNum(page) {
      this.searchParams.page = page;
      this.feedbackSearch();
    },
    searchKeyVal(item) {
      let text = item.desc;
      if (this.searchType === "desc") {
        let res = new RegExp(`(${this.searchVal})`, "g");
        text = text.replace(
          res,
          "<span style='color:red;'>" + this.searchVal + "</span>"
        );
      }
      return text;
    },

    async searchToHandleUserItem(item) {
      let userItem = await this.$store.dispatch(
        "findFeedbackUserInDB",
        item.dbId
      );
      // 如果不存在会话列表中则添加
      if (!userItem) {
        let msgList = await this.$store.dispatch("getFeedbackMsgFromCb", {
          selector: { dbId: item.dbId },
        });
        await this.$store.dispatch("filterFeedbackUserFromCB", {
          arr: [msgList[msgList.length - 1]],
          type: "search",
        });
        userItem = await this.$store.dispatch(
          "findFeedbackUserInDB",
          item.dbId
        );
      }

      setTimeout(async () => {
        // 把搜索到的会话排到第一位
        let tmpCbUserList = this.$_.cloneDeep(this.cbUserList);
        let idx = tmpCbUserList.findIndex(
          (item) => item.dbId === userItem.dbId
        );
        tmpCbUserList.splice(idx, 1);
        tmpCbUserList = [userItem, ...tmpCbUserList];
        this.$store.commit("UPDATE_CB_USER_LIST", tmpCbUserList);

        this.sessionItem = item;
        this.sessionDbID = item.dbId;
        console.log("pzz--search-sessionItem", this.sessionItem);

        this.$store.dispatch("setCbCurrentUser", item);
        await this.getMsgList();
        this.scrollToBottom();
        this.dialogSearchVisible = false;
      }, 500);
    },
    async handleUserItem(item) {
      if (this.sessionDbID === item.dbId) return;
      this.sessionItem = item;
      console.log("pzz--click-sessionItem", this.sessionItem);
      this.sessionDbID = item.dbId;
      this.$store.dispatch("setCbCurrentUser", item);
      await this.getMsgList();
      this.scrollToBottom();
    },
    async getMsgList() {
      this.setCurrentRemark(this.sessionDbID);

      // 并行请求消息和标签，减少串行等待时间
      const [msgList, res] = await Promise.all([
        this.$store.dispatch("getFeedbackMsgFromCb", {
          selector: { dbId: this.sessionItem.dbId },
        }),
        this.$http.getFeedbackTagsToCB({
          dbId: this.sessionItem.dbId,
        }),
      ]);

      // 使用 Map 实现 O(1) 标签合并，替代原来的 O(n*m) find()
      if (res.data && res.data.length) {
        const msgMap = new Map(msgList.map((m) => [m.uniqueId, m]));
        for (let item of res.data) {
          const tmp = msgMap.get(item.uniqueId);
          if (tmp) {
            tmp.tags = item.tags;
          }
        }
      }

      console.log("----------消息列表-------", msgList);
      await this.$store.dispatch("updateCbMsgList", msgList);
      return "ok";
    },

    filterMsgList(list) {
      let msgArr = JSON.parse(JSON.stringify(list));
      this.msgList.map((item) => {
        msgArr.map((subItem, index) => {
          if (item.sequence === subItem.sequence) {
            msgArr.splice(index, 1);
          }
        });
      });
      return msgArr;
    },

    async sendMsg() {
      if (this.sending) return;
      if (this.content === "" || this.content.trim().length === 0) {
        this.content = "";
        this.elMsg("不能发送空消息", "warning");
        return;
      }

      this.sending = true;
      if (this.files.length) {
        await this.uploadFileToOss();
      }

      const customMsgs = this.cbMsgList.filter(
        (item) => item.msgType === 0 && item.dbId === this.sessionItem.dbId
      );
      const lastMessage = customMsgs[customMsgs.length - 1];

      let params = {
        conversationId: this.sessionItem.conversationId,
        desc: this.content,
        uploadFileUrl: this.uploadFileUrl,
        name: this.userInfo.nickname,
        msgType: 1,
        msgStatus: 0,
        key: "",
        type: 0,
        isRead: false,
        isRevoke: false,
        dbId: this.sessionItem.dbId,
        user: this.userInfo.uid ? this.userInfo.uid : "onyx_admin",
        uniqueId: uuidv4(),
        targetId: lastMessage ? lastMessage.uniqueId : "",
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime(),
      };
      params._id = params.uniqueId;
      console.log("pzzz----sendMsg", params);
      try {
        this.content = "";
        this.uploadFileUrl = "";
        this.files = [];
        await this.setReadMsgStatus();
        let docs = await this.$store.dispatch("submitFeedbackMsgToCb", params);
        setTimeout(async () => {
          if (docs.length) {
            await this.$store.dispatch("filterFeedbackUserFromCB", {
              arr: docs,
            });
            console.log("---------pzzz----延迟5秒检查cb");
          }
        }, 5000);
        this.$store.dispatch("mergeCbMsgList", docs);
        this.sending = false;
        this.scrollToBottom();
      } catch (err) {
        console.log(err);
        this.sending = false;
        this.elMsg("信息发送失败，请重新发送", "error");
        this.scrollToBottom();
      }
    },

    async setReadMsgStatus() {
      try {
        let tmp = await this.$store.dispatch("getFeedbackMsgFromCb", {
          selector: {
            dbId: this.sessionItem.dbId,
            msgType: 0,
            $or: [{ isRead: false }, { isRead: { $exists: false } }],
          },
        });
        let ids = tmp.map((item) => item._id);
        console.log("-----准备设置成已读的信息-----", ids);
        return await this.$http.readMessage({ ids });
      } catch (error) {
        throw new Error(error);
      }
    },

    async checkPsw(item) {
      try {
        let res = await this.$http.getFeedbackPsw(item.key, {
          serverHost: item.serverInfo.onyxSend2BooxHostBaseUrl,
        });
        this.openCheckPsw(res.data);
      } catch (error) {
        this.elMsg("密码查询失败", "error");
      }
    },

    openCheckPsw(data) {
      this.$confirm(data.key, "密码查询", {
        confirmButtonText: "复制",
        showCancelButton: false,
        callback: async (type) => {
          if (type === "confirm") {
            await this.$copyText(data.key);
            this.elMsg("复制成功", "success");
          }
        },
      });
    },

    handleLine() {
      this.content += "\n";
    },

    scrollToBottom() {
      this.$nextTick(() => {
        let bar = this.$refs.feedbackContent || null;
        bar ? (bar.scrollTop = bar.scrollHeight) : null;
      });
    },

    scrollInSitu() {
      this.$nextTick(() => {
        let length = this.$refs.contentItem.length - 1;
        let item = this.$refs.contentItem[length];
        let bar = this.$refs.feedbackContent;
        bar.scrollTop = item.offsetTop;
      });
    },

    scrollToMsg() {
      this.$nextTick(() => {
        let currentMsg = this.$refs.contentItem.find(
          (item) => this.$route.query.MsgKey === item.id
        );
        let bar = this.$refs.feedbackContent;
        bar.scrollTop = currentMsg.offsetTop;
      });
    },

    async delConversation(item) {
      await this.$store.dispatch("deleteFeedbackUser", item.id);
      let idx = this.cbUserList.findIndex((ele) => ele.id === item.id);
      this.cbUserList.splice(idx, 1);
      this.$store.commit("UPDATE_CB_USER_LIST", this.cbUserList);

      if (this.sessionItem && this.sessionItem.dbId === item.dbId) {
        this.nextReqMessageID = "";
        this.serverMsgPage = 1;
        this.serverMsgCount = 0;
        this.serverMsg = [];
        this.imIsCompleted = false;
        this.isShowScrollButtomTips = false;
        this.sessionItem = null;
        this.sessionDbID = "";
        this.$store.dispatch("setCbCurrentUser", this.sessionItem);
      }
    },

    filterRevokeTime(item) {
      // let nowDate = new Date().getTime();
      // let time = item.createdAt;
      // return nowDate - time < 2 * 60 * 1000;
      return true;
    },
    resendMsg(msg) {
      // 重发：消息已在本地，直接重新推送，状态由 cbOutbox 驱动 UI（不弹提示）
      this.$store.dispatch("resendCbMsg", msg);
    },

    async revokeMsg(msg) {
      try {
        await this.$http.revokeCbMessage({ ids: [msg._id] });
        msg.isRevoke = true;
        // 清理发件箱状态，避免“发送中/失败 + 已撤回”的矛盾
        this.$store.commit("REMOVE_CB_OUTBOX", msg.uniqueId);
        await this.$store.dispatch("filterFeedbackUserFromCB", { arr: [msg] });
      } catch (error) {
        this.elMsg("消息撤回失败", "error");
      }
    },

    // async filterImSessionList() {
    //   return new Promise(async (resolve, reject) => {
    //     let arr = [];
    //     arr = this.sessionList.filter(item => {
    //       return !item.lastMessage.messageForShow;
    //     });
    //     if (!arr.length) {
    //       resolve("ok");
    //       return;
    //     }
    //     let arrId = arr.map(item => item.toAccount);
    //     try {
    //       let res = await this.$http.filiterFeedbackList({ ids: arrId });
    //       for (let item of res.data) {
    //         for (let obj of this.sessionList) {
    //           if (item._id === obj.toAccount) {
    //             obj.lastMessage.messageForShow = item.CustomMsgData;
    //             obj.lastMessage.lastTime = new Date(item.MsgTime).valueOf();
    //             continue;
    //           }
    //         }
    //       }
    //       resolve("ok");
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // },

    checkMore() {
      this.serverMsgPage += 1;
      this.getMsgList();
    },

    onScroll() {
      let bar = this.$refs.feedbackContent || null;
      this.isShowScrollButtomTips = bar
        ? bar.scrollHeight - bar.clientHeight - bar.scrollTop > 200
        : false;
    },

    focusInput() {},

    async setIdioms(text) {
      const myField = document.getElementById("singleText");
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        this.content =
          myField.value.substring(0, startPos) +
          text +
          myField.value.substring(endPos, myField.value.length);
        await this.$nextTick();
        myField.focus();
        myField.setSelectionRange(endPos + text.length, endPos + text.length);
      } else {
        this.content += text;
      }
    },

    async getSessionList() {
      // let modelBlacklists = await this.$http.getModelBlacklist({
      //   limit: 10000,
      // });
      // let models = modelBlacklists.data.results.map(item => item.model);
      // let listArr = Object.assign([], this.imSessionList);

      // let blackList = [];
      // let temp = [];
      // for (let item of listArr) {
      //   if (
      //     item.lastMessage.messageForShow.firmware &&
      //     models.includes(item.lastMessage.messageForShow.firmware.model)
      //   ) {
      //     let obj = {
      //       account: item.userProfile.userID,
      //       userId: item.userProfile.userID,
      //       name: item.lastMessage.messageForShow.name,
      //       phone: item.lastMessage.messageForShow.phone,
      //       email: item.lastMessage.messageForShow.email,
      //       sn: item.lastMessage.messageForShow.serialNumber,
      //       mac: item.lastMessage.messageForShow.firmware.deviceMAC,
      //       model: item.lastMessage.messageForShow.firmware.model
      //     };
      //     blackList = [...blackList, obj];
      //     console.log("将要拉黑的名单=======：", blackList);
      //   } else {
      //     temp = [...temp, item];
      //   }
      // }
      // if (blackList.length) {
      //   let userIds = blackList.map(item => item.account) || [];
      //   await this.$http.addBlacklists({ datas: blackList });
      //   await this.$tim.addToBlacklist(userIds);
      //   for (let id of userIds) {
      //     await this.$tim.delConversation(`C2C${id}`);
      //   }
      // }
      await this.sortSessionList();
    },

    async addBlackList() {
      try {
        await this.$confirm(null, "是否确认加入黑名单？", {
          confirmButtonText: this.$t("commonMsg.confirm"),
          cancelButtonText: this.$t("commonMsg.cancel"),
          showClose: false,
          center: true,
        });
        let obj = {
          account: this.sessionDbID,
          userId: this.sessionDbID,
          name: this.currentUser.payload.text.name,
          phone: this.currentUser.payload.text.phone,
          email: this.currentUser.payload.text.email,
          sn: this.currentUser.payload.text.serialNumber,
          mac: this.currentUser.payload.text.firmware.deviceMAC,
          model: this.currentUser.payload.text.firmware.model,
        };
        await this.$http.addBlacklists({ datas: [obj] });
        this.nextReqMessageID = "";
        this.serverMsgPage = 1;
        this.serverMsgCount = 0;
        this.serverMsg = [];
        this.imIsCompleted = false;
        this.sessionItem = null;
        this.sessionDbID = "";
        this.$store.dispatch(this.cbAction("setCbCurrentUser"), null);
      } catch (error) {}
    },

    //  ==============================================================

    async addFeedbackTags(item) {
      this.currentMsgItem = item;
      this.currentMsgTags = this.currentMsgItem.tags
        ? JSON.parse(JSON.stringify(this.currentMsgItem.tags))
        : [];
      this.showTagsTree = true;
    },

    async openTagsPopver() {
      this.currentMsgTagsKey =
        this.currentMsgTags && this.currentMsgTags.length
          ? this.currentMsgTags.map((i) => i.key)
          : [];
      let res = await this.$http.getFeedbackTagsTree({
        value: this.tagsSearchValue,
      });
      for (let data of res.data) {
        if (data.list.length) {
          for (let obj of data.list) {
            this.filterTagsData(obj, data.key);
          }
          this.setTagChildren(data, data.list[0]);
          this.childrenHasCheck(data);
        }
      }
      this.tagsData = res.data;
      // this.getSelectTags()
    },

    filterTagsData(item, category) {
      item.category = category;
      if (!item.parent || item.parent === null) {
        item.indeterminate = false;
      }
      if (this.currentMsgTagsKey.includes(item.key)) {
        item.check = true;
      } else {
        item.check = false;
      }
      if (item.children.length) {
        for (let data of item.children) {
          this.filterTagsData(data, category);
        }
      }
    },

    setTagChildren(parent, item) {
      parent.selectItem = item;
      parent.selectItemChildren = item.children;
    },

    childrenHasCheck(data) {
      for (let parent of data.list) {
        if (parent.children.length) {
          parent.indeterminate = parent.children.some((item) => item.check);
        }
      }

      // this.getSelectTags()
    },

    tagsSelectHandle(data, item) {
      this.childrenHasCheck(data);
      let arr = [];
      if (item.check) {
        let parentArr = this.findParent(data.list, item.parent);
        for (let data of parentArr.reverse()) {
          arr = [
            ...arr,
            {
              category: data.category,
              key: data.key,
              value: data.value,
            },
          ];
        }
        let current = {
          parent: arr,
          key: item.key,
          value: item.value,
          category: item.category,
        };
        this.currentMsgTags = [...this.currentMsgTags, current];
      } else {
        let index = this.currentMsgTags.find((obj) => obj.key === item.key);
        this.currentMsgTags.splice(index, 1);
      }
    },

    radioHandle(data, item) {
      if (item.check) {
        this.filterRadioStatus(data, item);
      }
    },

    filterRadioStatus(data, item) {
      for (let obj of data) {
        if (obj._id !== item._id) {
          obj.check = false;
        }
        if (obj.children && obj.children.length) {
          this.filterRadioStatus(obj.children, item);
        }
      }
    },

    tagsTreeSearch(val) {
      this.tagsSearchValue = val;
      this.openTagsPopver();
    },

    clearSelectTags() {
      this.currentMsgTagsKey = [];
      this.currentMsgTags = [];
      for (let item of this.tagsData) {
        for (let obj of item.list) {
          this.filterTagsData(obj, item.key);
        }
      }
      this.selectTags = [];
    },

    getSelectTags() {
      this.selectTags = [];
      for (let item of this.tagsData) {
        let list = this.getCheckedNodes(item.list);
        this.getParent(item.list, list);
        this.selectTags = [...this.selectTags, ...this.filterSelectTags(list)];
      }
    },

    getCheckedNodes(data, arr) {
      var res;
      if (arr == undefined) {
        res = new Array();
      } else {
        res = arr;
      }
      for (var item of data) {
        if (item.check) {
          res.push(item);
        }
        if (item.children !== undefined) {
          this.getCheckedNodes(item.children, res);
        }
      }
      return res;
    },

    filterSelectTags(arr) {
      let res = [];
      if (arr.length) {
        for (let item of arr) {
          res = [
            ...res,
            {
              parent: item.parentArr,
              key: item.key,
              value: item.value,
              category: item.category,
            },
          ];
        }
      }
      return res;
    },

    getParent(parentList, list) {
      for (let item of list) {
        if (item.check) {
          let parentArr = this.findParent(parentList, item.parent);
          let arr = [];
          for (let data of parentArr.reverse()) {
            arr = [
              ...arr,
              {
                category: data.category,
                key: data.key,
                value: data.value,
              },
            ];
          }
          item.parentArr = arr;
        } else {
          delete item.parentArr;
        }
      }
    },

    findParent(parentList, parentId, arr) {
      var res;
      if (arr == undefined) {
        res = new Array();
      } else {
        res = arr;
      }
      for (var item of parentList) {
        if (item._id === parentId) {
          res.push(item);
          if (item.parent && item.parent !== null) {
            this.findParent(parentList, item.parent, res);
          }
        } else {
          if (item.children !== undefined) {
            this.findParent(item.children, parentId, res);
          }
        }
      }
      return res;
    },

    async tagsConfirm() {
      if (!this.currentMsgItem.uniqueId) return;
      try {
        this.tagLoading = true;
        let params = {
          tagUser: this.userInfo.id,
          MsgKey: this.currentMsgItem.uniqueId,
          tags: this.currentMsgTags,
        };
        let res = await this.$http.addTagsToFeedback(params);
        // await this.$http.setFeedbackTagsToCB({
        //   tags: res.data.tags,
        //   ids: [this.currentMsgItem.uniqueId]
        // })
        this.tagLoading = false;
        this.currentMsgItem.tags = res.data.tags;
        this.closeTagsPopver();
      } catch (error) {
        this.tagLoading = false;
      }
    },

    closeTagsPopver() {
      this.currentMsgItem = null;
      this.currentMsgTagsKey = [];
      this.currentMsgTags = [];
      this.tagsSearchValue = "";
      this.showTagsTree = false;
    },

    checkMsgKey() {
      this.$nextTick(async () => {
        if (this.$route.query.MsgKey) {
          let res = await this.$store.dispatch("getFeedbackMsgFromCb", {
            selector: { uniqueId: this.$route.query.MsgKey },
          });
          if (!res.length) {
            this.elMsg("没有搜索到内容", "warning");
            return;
          }
          this.searchToHandleUserItem(res[0]);
        }
      });
    },
  },
  async beforeUnmount() {},
  async mounted() {
    this.getRemark();
    this.checkMsgKey();
  },
};
</script>

<style lang="scss">
.feedback-info-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .feedback-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .feedback-main-left {
      width: 300px;
      background: #30363e;
      height: 100%;
      display: flex;
      flex-direction: column;
      /* padding: 0 10px; */
      overflow: hidden;
      .feedback-main-left-btn {
        padding: 10px 20px 10px 0;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > .feedback-main-left-select {
          display: flex;
          align-items: center;
          > .el-select {
            width: 80px;
          }
          > .feedback-main-left-sortBy {
            cursor: pointer;
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            > .feedback-main-left-icon {
              color: #ccc;
            }
            > .activeSortIcon {
              color: $globalBGColor;
            }
          }
        }
      }
      .feedback-main-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        .activeUserItem {
          background: #505a64;
        }
        .feedback-main-item {
          display: flex;
          padding: 15px 10px;
          cursor: pointer;
          position: relative;
          &:hover {
            background: #505a64;
            .feedback-del-btn {
              display: block;
            }
          }
          .feedback-del-btn {
            position: absolute;
            right: 10px;
            top: 5px;
            font-size: 18px;
            color: #fff;
            font-weight: bold;
            display: none;
            &:hover {
              color: #ef5655;
            }
          }
          .feedback-main-item-info {
            flex: 1;
            margin-left: 10px;
            overflow: hidden;
            .feedback-main-item-Top {
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
              .feedback-main-item-account {
                width: 85%;
                color: #fff;
                font-weight: bold;
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .feedback-main-item-unReadCount {
                width: 20px;
                height: 20px;
                text-align: center;
                border-radius: 50%;
                background: #ef5655;
                color: #fff;
                /* margin-left: 10px; */
              }
            }
            .feedback-main-item-Bottom {
              /* display: flex;
              justify-content: space-between; */
              margin-top: 5px;
              .feedback-main-item-msg {
                width: 90%;
                color: #8e9daa;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .feedback-main-item-text {
            color: #8e9daa;
            font-size: 8px;
          }
        }
      }
    }
    .feedback-main-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #f3f3f3;
      overflow: hidden;
      .feedback-userName {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
        > h2 {
          flex: 1;
        }
        .blackListBtn {
          /* flex: 1; */
        }
      }
      .feedback-content {
        flex: 1;
        overflow: hidden;
        .scrollButtomTips {
          position: absolute;
          bottom: 5px;
          left: 50%;
          transform: translate(-50%, 0);
          cursor: pointer;
          background: $globalBGColor;
          color: #fff;
          padding: 0px 8px;
          border-radius: 10px;
          font-size: 10px;
          z-index: 100;
        }
        .checkMore-btn {
          text-align: center;
          color: $globalBGColor;
          cursor: pointer;
        }
        .feedbackContent-noMore {
          text-align: center;
          color: #8e9daa;
        }
        .feedbacl-content-item {
          padding: 20px;
          .feedbacl-content-info {
            display: flex;
            .feedback-content-item-pic-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .feedback-content-item-pic {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
            .feedback-content-item-info {
              margin: 0 10px;
              width: 60%;
              .feedback-content-item-text-warp {
                display: flex;
                align-items: center;
                .feedback-content-item-tag {
                  width: 20px;
                  height: 20px;
                  margin-left: 10px;
                  cursor: pointer;
                }
              }
              .feedback-content-item-text {
                padding: 5px;
                border-radius: 5px;
                /* word-break: break-all; */
                background: #fff;
                display: inline-block;
                word-wrap: break-word;
                overflow: hidden;
                word-break: break-word;
              }
              .feedback-content-item-firmware {
                margin-top: 5px;
                .feedback-tag-value {
                  color: $globalBGColor;
                  font-weight: bold;
                }
              }
              .feedback-content-item-file {
                margin-top: 5px;
                .feedback-content-item-fileUrl {
                  color: #56a3fd;
                  text-decoration: underline;
                  margin-right: 10px;
                }
              }
              .feedback-content-item-time {
                font-size: 10px;
                color: #8e9daa;
              }
            }
          }
          .feedbacl-content-out {
            justify-content: flex-end;
            .feedbacl-content-out-text {
              position: relative;

              display: flex;
              flex-direction: column;
              align-items: flex-end;
              &:hover {
                .feedback-revoke-btn {
                  display: block;
                }
              }
              .feedback-sendFail-btn {
                font-size: 16px;
                color: #ef5655;
                border-radius: 50px;
                cursor: pointer;
                font-weight: bold;
                margin-right: 5px;
              }
              .feedback-sending-btn {
                font-size: 16px;
                color: #999;
                margin-right: 5px;
              }
              .feedback-revoke-btn {
                position: absolute;
                right: -5px;
                top: -5px;
                color: #fff;
                border-radius: 50px;
                background: #ef5655;
                cursor: pointer;
                font-weight: bold;
                display: none;
              }
              .feedbacl-out-content-text {
                background: #56a3fd;
                color: #fff;
              }
            }
          }
        }
      }
      .feedback-file {
        display: flex;
        align-items: center;
        padding: 0 10px;
        background: #fff;
        > .feedback-upload-file {
          margin-left: 10px;
        }
      }
      .feedback-input {
        height: 150px;
        border-top: 1px solid #ccc;
        position: relative;
        > .el-textarea {
          > .el-textarea__inner {
            height: 150px;
            border-color: #fff;
          }
        }
        .feedback-sendBtn {
          display: flex;
          position: absolute;
          right: 5px;
          bottom: 5px;
          .feedback-phrase {
          }
        }
      }
    }
  }
  .feedback-dialog-main {
    height: 100%;
    > .el-dialog {
      height: 70%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .el-dialog__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .feedback-dialogSearch-warp {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .feedback-dialogSearch-input {
          display: flex;
          padding: 0 0 10px;
          border-bottom: 1px solid #ccc;
          .feedback-dialogSearch-select {
            width: 100px;
            margin-right: 10px;
          }
          .feedback-dialogSearch-search-icon {
            cursor: pointer;
          }
        }
        .feedback-searchList {
          flex: 1;
          .feedback-searchItem {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #ccc;
            cursor: pointer;
            &:hover {
              background: #f3f6f9;
            }
            .feedback--searchItem-msgInfo {
              flex: 1;
              display: flex;
              align-items: center;
              padding: 0 10px;
              > span {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
  .feedback-main-item-pic {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
}

.tagsTree-dialog {
  overflow: hidden;
  > .el-dialog {
    margin-top: 4vh !important;
    height: calc(100% - 80px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .el-dialog__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      overflow: hidden;
      .feedback-tagsTree-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .feedback-tagsTree-selectTags {
          > .feedback-tag-value {
            color: $globalBGColor;
            font-weight: bold;
          }
        }
        .feedback-tagsTree-btn {
          display: flex;
          align-items: center;
          .feedback-tagsTree-search {
            margin-right: 10px;
          }
        }
      }
      .feedback-tagsTree {
        /* flex: 1; */
        display: flex;
        flex-direction: column;
        border: 1px solid #ccc;
        .feedback-tags-item + .feedback-tags-item {
          border-top: 1px solid #ccc;
        }
        .feedback-tags-item {
          display: flex;
          /* padding: 20px 0; */
          .feedback-tags-item-left {
            display: flex;
            border-right: 1px solid #ccc;
            width: 35%;
            .feedback-tags-item-type {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px;
            }
            .feedback-tags-funct-list {
              flex: 1;
              border-left: 1px solid #ccc;
              max-height: 290px;
              overflow: hidden;
              .feedback-tags-funct-item {
                padding: 5px 10px;
                margin: 5px 0;
                cursor: pointer;
                &:hover {
                  background: $globalLessBGColor;
                  color: #fff;
                }
              }
              .active-functItem {
                background: $globalLessBGColor;
                color: #fff !important;
              }
              .functItem-color {
                color: $globalBGColor;
              }
            }
          }
          .feedback-tags-item-right {
            flex: 1;
            display: flex;
            overflow: hidden;
            /* align-items: center; */
            max-height: 290px;
            .feedback-tags-list {
              display: flex;
              flex: 1;
              flex-wrap: wrap;
              padding: 0 20px;
              line-height: 40px;
              /* .feedback-tags-item-check + .feedback-tags-item-check {
                margin-left: 20px;
              } */
              .feedback-tags-item-check {
                width: 20%;
                display: flex;
                align-items: center;
                > p {
                  cursor: pointer;
                  margin: 0 20px 0 5px;
                }
              }
            }
          }
        }
        /* .feedback-tagsFunct {
          flex: 1;
        } */
      }
    }
  }
}

.feedback-tags-tree {
  .treeNode {
    .tagsTree-node-scope {
      > .tagsTree-node-wrap {
        display: flex;
        align-items: center;
        margin-top: 14px;
        .tagsTree-node-item {
          position: relative;
          margin-left: 20px;
          .tagsTree-node-expand-btn {
            position: absolute;
            top: 50%;
            left: -14px;
            transform: translate(0, -50%);
            cursor: pointer;
          }
          .tagsTree-node-title {
            cursor: pointer;
          }
        }
      }
    }
    > .tagsTree-node-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .activeTreeTagTitle {
      color: $globalBGColor;
    }
  }
}
</style>
